import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage,
  Font
} from '@react-pdf/renderer';

Font.register({
  family: 'Roboto',
  fonts: [{ src: '/Roboto-Bold.ttf', fontWeight: 'bold' }]
});

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};

const styles = StyleSheet.create({
  page: {
    justifyContent: 'flex-start',
    alignItems: 'center'
  },
  boldText: {
    fontFamily: 'Roboto',
    fontWeight: 'ultrabold',
    fontSize: '10px'
  },
  text: {
    fontSize: 8,
    marginLeft: 10,
    marginRight: 10
  },
  textUnderlined: {
    fontSize: 8,
    textDecoration: 'underline'
  },
  heading: {
    fontSize: 14,
    fontWeight: 'ultrabold',
    marginBottom: 10,
    textAlign: 'center'
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: 40,
    marginTop: 6,
    border: '1.2px solid black',
    paddingLeft: 20,
    paddingRight: 70,
    // paddingBottom: 40,
    paddingTop: 5
  },
  column1: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0,
    marginRight: '10%'
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0,
    marginLeft: '5%'
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    paddingBottom: 5
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    padding: 5,
    border: '1px solid black',
    marginTop: 10,
    // backgroundColor: 'navy',
    color: 'black'
  },
  headerText: {
    fontSize: 8,
    fontWeight: 'bold',
    marginLeft: 25,
    marginRight: 25
  },
  columnHeader: {
    width: 'auto'
  },
  columnText: {
    width: '10%',
    textAlign: 'center'
  },
  columnTextWide: {
    width: '17%',
    textAlign: 'center'
  },
  columnTextNarrow: {
    width: '5%',
    textAlign: 'center'
  }
});

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

const getCurrentDate = () => {
  const date = new Date();
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};






export const IndoorBillManagementReportPdf = ({ data }) => {
  console.log(data);
  function formatDate(dateString) {
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); 
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }
  const totalSubTotalAmount = data?.indoorService?.reduce((total, item) => total + parseFloat(item.total_amt || 0), 0);
  const totalSubTotalRoomAmount = data?.roomChargeTracker?.reduce(
    (total, item) => total + parseFloat(item.charge || 0),
    0
  );
  const totalRoomCharge = data?.roomChargeTracker?.reduce((total, item) => total + parseFloat(item.net_amt || 0), 0);
  const totalNetAmount = data?.indoorService?.reduce((total, item) => total + parseFloat(item.net_amt || 0), 0);
  const totalDiscountAmt = data?.indoorService?.reduce((total, item) => total + parseFloat(item.disc_amt || 0), 0);
  const addTotalDiscountAmt = data?.indoorService?.reduce(
    (total, item) => total + parseFloat(item.add_discount || 0),
    0
  );
  const addTotalDiscountRoomAmt = data?.roomChargeTracker?.reduce(
    (total, item) => total + parseFloat(item.disc_amt || 0),
    0
  );

  const amountReceivedByIndoorservice = data?.indoorService?.reduce(
    (total, item) => total + parseFloat(item.total_recpt || 0),
    0
  );

  const amountReceivedByReceiptVoucher = data?.receiptVouchers?.reduce(
    (total, item) => total + parseFloat(item.received_amount || 0),
    0
  );

  const amountRefundByRefundVoucher = data?.paymentRefundVouchers?.reduce(
    (total, item) => total + parseFloat(item?.amount || 0),
    0
  );

  const billingDate = formatDate(data?.billing_date);
  const dateTimeToRender = data?.dateTime && data.dateTime !== '-' ? formatDate(data.dateTime) : formatDate(new Date());

  const groupedData = data?.roomChargeTracker.reduce((acc, item) => {
    if (!acc[item.ward_name]) {
      acc[item.ward_name] = {
        ward_name: item.ward_name,
        room_no: item.room_no,
        date : item.date,
        bed_no: item.bed_no,
        Rate: item.charge,
        totalQuantity: 0,
        Disc:0,
        totalNetAmount: 0,
        items: []
      };
    }
    acc[item.ward_name].totalNetAmount += item.net_amt;
    acc[item.ward_name].totalQuantity += 1;
    acc[item.ward_name].items.push(item);
    return acc;
  }, {});
  const groupedDataArray = Object.values(groupedData);

  const allServiceItems = data.indoorService.flatMap(indoorServiceItem => indoorServiceItem.service_items);
const groupedServiceItems = allServiceItems.reduce((acc, item) => {
  const group = item.sub_group_name.toLowerCase(); 
  if (!acc[group]) acc[group] = [];
  acc[group].push(item);
  return acc;
}, {});

const sortedGroupNames = Object.keys(groupedServiceItems).sort((a, b) => {
  const firstLetterA = a.charAt(0).toLowerCase();
  const firstLetterB = b.charAt(0).toLowerCase();
  return firstLetterA.localeCompare(firstLetterB);
});

const formatRegTime = (time) => {
  const [hours, minutes] = time.split(':');
  const date = new Date();
  date.setHours(hours);
  date.setMinutes(minutes);
  // Format to 12-hour time
  const options = { hour: '2-digit', minute: '2-digit', hour12: true };
  return date.toLocaleTimeString('en-US', options);
};


  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title={`${data.patientName}'s Final Bill`}>
          <Page size="A4" style={styles.page}>
            <PDFImage
              src="/logo_Hospital_m.jpeg"
              style={{ width: '100%', height: '80px', marginBottom: 1, marginRight: '5%',paddingLeft:"20px",marginTop:'2%' }}
            />
            <Text
              content={data.billLabel}
              style={{ ...styles.boldText, borderBottom: '1px solid black', fontSize: '18px' }}
            />
            <View style={styles.contentContainer}>
              <View style={styles.column1}>
                <View style={styles.row}>
                  <Text content="UHID NO                :- " style={{ fontSize: 8, fontFamily: 'Roboto' }} />
                  <Text content={`${data.uhid}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Name                     :- " style={{ fontSize: 8, fontFamily: 'Roboto' }} />
                  <Text content={`${data.patientName}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Age/Gender          :- " style={{ fontSize: 8, fontFamily: 'Roboto' }} />
                  <Text content={`${data.age} / ${data.gender}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Doctor                    :- " style={{ fontSize: 8, fontFamily: 'Roboto' }} />
                  <Text content={`${data.consultant.doctor}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Department           :- " style={{ fontSize: 8, fontFamily: 'Roboto' }} />
                  <Text content={`${data.department}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Address                 :- " style={{ fontSize: 8, fontFamily: 'Roboto' }} />
                  <Text content={`${data.address}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Ward/Bed No.       :- " style={{ fontSize: 8, fontFamily: 'Roboto' }} />
                  <Text content={`${data?.ward}  /  ${data?.consultantDetail?.bed_no}`} />
                </View>
              </View>
              <View style={styles.column}>
                <View style={styles.row}>
                  <Text content="Ipd No                         :- " style={{ fontSize: 8, fontFamily: 'Roboto' }} />
                  <Text content={`${data.ipd_no}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Bill No.                        :- " style={{ fontSize: 8, fontFamily: 'Roboto' }} />
                  <Text content={`${data.finalBillNo || '-'}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Bill Date                      :- " style={{ fontSize: 8, fontFamily: 'Roboto' }} />
                  <Text content={dateTimeToRender} />
                </View>
                <View style={styles.row}>
                  <Text content="Addmission Date       :- " style={{ fontSize: 8, fontFamily: 'Roboto' }} />
                  <Text content={`${formatDate(data?.admission_date)}/${formatRegTime(data?.admission_time)}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Discharge Date          :- " style={{ fontSize: 8, fontFamily: 'Roboto' }} />
                  <Text content={`${data?.dischargeDate === '-' ? '-' : formatDate(data?.dischargeDate) }/${formatRegTime(data?.dischargeTime)}`}  />
                </View>
                <View style={styles.row}>
                  <Text content="Sponsor                       :- " style={{ fontSize: 8, fontFamily: 'Roboto' }} />
                  <Text content={`${data.sponsor}`} />
                </View>
                <View style={styles.row}>
                  <Text content="TPA/Insurance            :- " style={{ fontSize: 8, fontFamily: 'Roboto' }} />
                  <Text content="" />
                </View>
              </View>
            </View>
            <View style={styles.headerContainer}>
              <Text content="Charge" style={{ ...styles.columnTextNarrow, width: '10%', fontFamily: 'Roboto' }} />
              <Text content="Head" style={{ ...styles.columnText, width: '10%', fontFamily: 'Roboto' }} />
              <Text content="Description" style={{ ...styles.columnTextWide, width: '25%', fontFamily: 'Roboto' }} />
              <Text content="Qty" style={{ ...styles.columnText, width: '5%', fontFamily: 'Roboto' }} />
              <Text content="Rate" style={{ ...styles.columnText, width: '10%', fontFamily: 'Roboto' }} />
              <Text content="Dis" style={{ ...styles.columnText, width: '10%', fontFamily: 'Roboto' }} />
              <Text content="Amount (Rs)" style={{ ...styles.columnText, width: '10%', fontFamily: 'Roboto' }} />
            </View>
            {sortedGroupNames.map((groupName, groupIndex) => (
  <>
    <Text
      style={{
        ...styles.columnText,
        width: '90%',
        textAlign: 'start',
        fontSize: '10px',
        marginBottom: '2%',
        fontFamily: 'Roboto',
        marginTop: "1%"
      }}
      content={groupName.toUpperCase()}
    />
    {groupedServiceItems[groupName].map((serviceItem, serviceIndex) => (
      <View style={{ ...styles.row,  padding: "5px",marginBottom:"0.5%" }} key={`${groupIndex}-${serviceIndex}`}>
        <Text style={{ ...styles.columnTextWide, width: '24%',  }} content={serviceItem.service_name} />
        <Text
          style={{ ...styles.columnText, width: '12%', }}
          content={formatDate(serviceItem.billingDate)}
        />
             <Text style={{ ...styles.columnText, width: '12%',}} content={serviceItem.quantity} />
        <Text style={{ ...styles.columnText, width: '12%',}} content={serviceItem.rate} />
        <Text style={{ ...styles.columnText, width: '12%',}} content={serviceItem.disc_amt} />
        <Text style={{ ...styles.columnText, width: '12%' }} content={serviceItem.amount} />
      </View>
    ))}
    <View style={{ ...styles.row, padding: "5px", marginLeft: "75%" }}>
      <Text style={{ ...styles.columnTextWide, width: '40%', fontFamily: "Roboto" }} content={"Sub Total"} />
      <Text style={{ ...styles.columnTextWide, width: '10%' }} content={groupedServiceItems[groupName].reduce((sum, item) => sum + parseFloat(item.amount), 0)}
      />
    </View>
  </>
))}
{groupedDataArray.map((group, index) => (
  <>
    <Text content={"ROOM CHARGES"} style={{ ...styles.columnText, width: '90%', textAlign: "start", fontFamily: "Roboto", fontSize: "10px", marginTop: "1%" }} />
    <View key={index} style={{ ...styles.row, marginTop: 10,  padding: "5px", width: "100%" }}>
      <Text content={`${group.ward_name}/${group.room_no}/${group.bed_no}`} style={{ ...styles.columnText, width: '24%',  }} />
      <Text content={formatDate(group.date)} style={{ ...styles.columnText, width: '12%', }} />
      <Text content={group.Rate} style={{ ...styles.columnText, width: '12%',  }} />
      <Text content={group.totalQuantity} style={{ ...styles.columnText, width: '12%',  }} />
      <Text content={group.Disc} style={{ ...styles.columnText, width: '12%',  }} />
      <Text content={group.totalNetAmount} style={{ ...styles.columnText, width: '24%' }} />
    </View>
    <View key={index} style={{ ...styles.row, marginTop: 10, marginLeft: "62%" }}>
      <Text content={`Sub Total`} style={{ ...styles.columnText, width: '20%', fontFamily: "Roboto" }} />
      <Text content={group.totalNetAmount} style={{ ...styles.columnText, width: '10%' }} />
    </View>
  </>
))}
            <View style={{ ...styles.row }}>
              <Text
                content="Total Bill Amount:"
                style={{ ...styles.columnTextWide, fontWeight: 'bold', marginLeft: '58%' }}
              />
              <Text content={`${totalSubTotalAmount + totalSubTotalRoomAmount}`} style={{ ...styles.columnText }} />
            </View>
            <View style={{ ...styles.row }}>
              <Text content="Discount:" style={{ ...styles.columnTextWide, fontWeight: 'bold', marginLeft: '57%' }} />
              <Text
                content={`${totalDiscountAmt + addTotalDiscountAmt + addTotalDiscountRoomAmt}`}
                style={{ ...styles.columnText }}
              />
            </View>
            <View style={{ ...styles.row }}>
              <Text
                content="Net Bill Amount:"
                style={{ ...styles.columnTextWide, fontWeight: 'bold', marginLeft: '57%' }}
              />
              <Text content={`${totalRoomCharge + totalNetAmount}`} style={{ ...styles.columnText }} />
            </View>
            <View style={{ ...styles.row }}>
              <Text
                content="Amount Received:"
                style={{ ...styles.columnTextWide, fontWeight: 'bold', marginLeft: '57%' }}
              />
              <Text
                content={`${amountReceivedByIndoorservice + amountReceivedByReceiptVoucher}`}
                style={{ ...styles.columnText }}
              />
            </View>
            <View style={{ ...styles.row }}>
              <Text content="Balance:" style={{ ...styles.columnTextWide, fontWeight: 'bold', marginLeft: '57%' }} />
              <Text
                content={
                  totalSubTotalAmount + totalSubTotalRoomAmount +
                  amountRefundByRefundVoucher -
                  (amountReceivedByIndoorservice +
                    amountReceivedByReceiptVoucher +
                    totalDiscountAmt +
                    addTotalDiscountAmt +
                    addTotalDiscountRoomAmt)
                }
                style={{ ...styles.columnText }}
              />
            </View>
            <Text content="Reciept Voucher" style={{ ...styles.columnTextWide, fontFamily: 'Roboto' }} />
            <View style={{ ...styles.headerContainer, width: '100%' }}>
              <Text content="S No." style={{ ...styles.columnTextNarrow, width: '10%', fontFamily: 'Roboto' }} />
              <Text content="Date" style={{ ...styles.columnTextNarrow, width: '10%', fontFamily: 'Roboto' }} />
              <Text content="IPD No." style={{ ...styles.columnText, width: '10%', fontFamily: 'Roboto' }} />
              <Text content="Payment Mode" style={{ ...styles.columnTextWide, width: '25%', fontFamily: 'Roboto' }} />
              <Text content="Receipt No." style={{ ...styles.columnText, width: '15%', fontFamily: 'Roboto' }} />
              <Text content="Payment Type" style={{ ...styles.columnText, width: '15%', fontFamily: 'Roboto' }} />
              <Text content="Received Amount" style={{ ...styles.columnText, width: '30%', fontFamily: 'Roboto' }} />
            </View>

            {data.receiptVouchers && data.receiptVouchers.length > 0 ? (
              data.receiptVouchers.map((voucher, index) => (
                <View
                  style={{
                    ...styles.row,
                    backgroundColor: index % 2 !== 0 ? '#ffffff' : '#f7f7f7',
                    marginTop: 5,
                    width: '100%'
                  }}
                  key={voucher._id}
                >
                  <Text content={index + 1} style={{ ...styles.columnTextNarrow, width: '10%' }} />
                  <Text
                    content={`${formatDate(voucher?.date)} ${voucher?.time}`}
                    style={{ ...styles.columnTextNarrow, width: '15%' }}
                  />
                  <Text content={data.ipd_no || '-'} style={{ ...styles.columnText, width: '10%' }} />
                  <Text content={voucher.payment_mode || '-'} style={{ ...styles.columnTextWide, width: '25%' }} />
                  <Text content={voucher.receipt_no || '-'} style={{ ...styles.columnText, width: '15%' }} />
                  <Text content={voucher.payment_type || '-'} style={{ ...styles.columnText, width: '15%' }} />
                  <Text content={voucher.received_amount || '0'} style={{ ...styles.columnText, width: '30%' }} />
                </View>
              ))
            ) : (
              <View style={{ ...styles.row }}>
                <Text content="No receipts found" style={{ ...styles.columnTextNarrow, width: '100%' }} />
                <Text content="-" style={styles.columnText} />
                <Text content="-" style={styles.columnTextWide} />
                <Text content="-" style={styles.columnText} />
                <Text content="-" style={{ ...styles.columnText, width: '20%' }} />
              </View>
            )}
            <Text
              content="Refund Voucher"
              style={{ ...styles.columnTextWide, marginTop: '5%', fontFamily: 'Roboto' }}
            />
            <View style={{ ...styles.headerContainer, width: '100%' }}>
              <Text content="Sr No." style={{ ...styles.columnTextNarrow, width: '10%', fontFamily: 'Roboto' }} />
              <Text content="Date" style={{ ...styles.columnTextNarrow, width: '10%', fontFamily: 'Roboto' }} />
              <Text content="IPD No." style={{ ...styles.columnText, width: '10%', fontFamily: 'Roboto' }} />
              <Text content="Payment Mode" style={{ ...styles.columnTextWide, width: '25%', fontFamily: 'Roboto' }} />
              <Text content="Reciept No." style={{ ...styles.columnText, width: '15%', fontFamily: 'Roboto' }} />
              <Text content="Payment Type" style={{ ...styles.columnText, width: '15%', fontFamily: 'Roboto' }} />
              <Text content="Amount" style={{ ...styles.columnText, width: '30%', fontFamily: 'Roboto' }} />
            </View>

            {data.paymentRefundVouchers && data.paymentRefundVouchers.length > 0 ? (
              data.paymentRefundVouchers.map((voucher, index) => (
                <View
                  style={{
                    ...styles.row,
                    backgroundColor: index % 2 !== 0 ? '#ffffff' : '#f7f7f7',
                    marginTop: 5,
                    width: '100%'
                  }}
                  key={voucher._id}
                >
                  <Text content={index + 1} style={{ ...styles.columnTextNarrow, width: '10%' }} />
                  <Text
                    content={`${formatDate(voucher?.date)} ${voucher?.time}`}
                    style={{ ...styles.columnTextNarrow, width: '15%' }}
                  />
                  <Text content={data.ipd_no || '-'} style={{ ...styles.columnText, width: '10%' }} />
                  <Text content={voucher.payment_mode || '-'} style={{ ...styles.columnTextWide, width: '25%' }} />
                  <Text content={voucher.doc_no || '-'} style={{ ...styles.columnText, width: '15%' }} />
                  <Text content={voucher.payment_type || '-'} style={{ ...styles.columnText, width: '15%' }} />
                  <Text content={voucher.amount || '0'} style={{ ...styles.columnText, width: '30%' }} />
                </View>
              ))
            ) : (
              <View style={{ ...styles.row }}>
                <Text content="No Refund  Found" style={{ ...styles.columnTextNarrow, width: '100%' }} />
                <Text content="-" style={styles.columnText} />
                <Text content="-" style={styles.columnTextWide} />
                <Text content="-" style={styles.columnText} />
                <Text content="-" style={{ ...styles.columnText, width: '20%' }} />
              </View>
            )}

            <View style={{ ...styles.row, marginTop: '15%' }}>
              <Text
                content="Authorized Signatory"
                style={{ ...styles.columnTextWide, fontWeight: 'bold', marginLeft: '65%' }}
              />
              <Text content="" style={{ ...styles.columnText }} />
            </View>
            <View style={{ ...styles.row, marginTop: '0' }}>
              <Text content="Patient/Attendent Signatory:" style={{ fontWeight: 'bold', marginRight: '60%' }} />
            </View>
            <View style={{ ...styles.row, marginTop: '2%' }}>
              <Text content="Relation With Patient:" style={{ fontWeight: 'bold', marginRight: '60%' }} />
            </View>
            <View style={{ ...styles.row, marginTop: '2%' }}>
              <Text content="Mobile No.:" style={{ fontWeight: 'bold', marginRight: '60%' }} />
            </View>
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
};
